import { Button, UncontrolledTooltip } from 'reactstrap';
import { useTranslation } from 'react-i18next';

export const EngagementsHeadingTooltip = () => {
  const { t } = useTranslation();
  return (
    <>
      {' '}
      <Button
        id={'engagementsInfoButton'}
        size="lg"
        color="none"
        className="position-absolute heading-tooltip border-0"
      >
        <i className="fa fa-question-circle text-muted"></i>
      </Button>
      <UncontrolledTooltip
        target={'engagementsInfoButton'}
        placement="bottom-start"
        container="body"
        delay={{ show: 50, hide: 50 }}
        style={{
          minWidth: '300px',
          backgroundColor: 'var(--balance-profie-bg)',
        }}
      >
        <div className="d-flex flex-column text-start">
          <p className="p-0 m-0">
            <span className="f-w-700 d-inline">{t('engagements.tooltip.descr0')}</span>
            {t('engagements.tooltip.descr1')}
          </p>
          <p className="p-0 m-0">{t('engagements.tooltip.descr2')}</p>
          <p className="p-0 mb-0 mt-2">
            <span className="f-w-700 d-inline">{t('engagements.tooltip.descr3')} </span>
            {t('engagements.tooltip.descr4')}
          </p>
        </div>
      </UncontrolledTooltip>
    </>
  );
};
